// extracted by mini-css-extract-plugin
export var active = "main-blocks-mobile-tabs-module--active--00eb6";
export var blockHeaderPicto = "main-blocks-mobile-tabs-module--blockHeaderPicto--ff5d2";
export var mainBlockHeader = "main-blocks-mobile-tabs-module--mainBlockHeader--0209e";
export var mainBlocksTabs = "main-blocks-mobile-tabs-module--mainBlocksTabs--c6468";
export var tabTitle = "main-blocks-mobile-tabs-module--tabTitle--9e31a";
export var triangle = "main-blocks-mobile-tabs-module--triangle--4baec";